import type { TableColumnType } from 'ant-design-vue'
import type { ExtractPropTypes, PropType } from 'vue'
export type TableFormColumnType = TableColumnType & {
  help?: any
  [key: string]: any
}
export const tableFormProps = {
  dataSync: {
    type: Array as PropType<any[]>,
    default: () => []
  },
  columns: {
    type: Array as PropType<TableColumnType[]>,
    default: () => []
  },
  defaultData: {
    type: Object as PropType<any>
  },
  addVisible: {
    type: Boolean as PropType<boolean>,
    default: true
  },
  addDisabled: {
    type: Function as PropType<() => boolean>
  },
  delVisible: {
    type: Boolean as PropType<boolean>,
    default: true
  },
  delDisabled: {
    type: Function as PropType<(opt: any) => boolean>
  },
  useEvent: {
    type: Boolean as PropType<boolean>,
    default: false
  }
}

export type TableFormProps = ExtractPropTypes<typeof tableFormProps>
